import React from "react";
import { Container, CssBaseline, Typography } from "@mui/material";
import { AppBar, Menu } from "components";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const NotFound = (props) => {
  const classes = useStyles();
  const [menuOpen, setMenuOpen] = React.useState(false);

  const { t } = useTranslation();

  return (
    <Container>
      <CssBaseline />
      <AppBar
        open={menuOpen}
        onOpen={() => setMenuOpen(true)}
        title={t("general.notFoundTitle")}
      />
      <Menu
        items={props.menuItems}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      />
      <main className={classes.main}>
        <Typography variant="h5">{t("general.notFound")}</Typography>
      </main>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  screen: {
    display: "flex",
  },
  main: {
    marginTop: theme.spacing(15),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default NotFound;
